import { SubscriptionTierMenu } from './subscriptionTierMenu';
import {
  onSelectTierProps,
  SubscriptionTier,
} from './subscriptionTierSelector';

export const getSubscriptionTierColumn = (
  info: any,
  tierList: SubscriptionTier[],
  onSelect: (props: onSelectTierProps) => Promise<void>
) => {
  const workspace = info.row.original;
  const { id, subscriptionTierId } = workspace || {};

  if (!id) {
    return null;
  }

  const currentTier = tierList.find((tier) => tier.id === subscriptionTierId);
  const currentTierName = currentTier?.name;

  return (
    <SubscriptionTierMenu
      workspaceId={id}
      currentTierId={subscriptionTierId}
      currentTierName={currentTierName}
      onSelect={onSelect}
      tierList={tierList}
    />
  );
};
